import { useSelector, useDispatch } from "react-redux";
import { setSkylineVisible } from "../../redux/sensorAnalysis";
import WindowOrSensorSkyline from "./WindowOrSensorSkyline";

const SensorSkyline = () => {
  const dispatch = useDispatch();

  const skylineState = useSelector((state) => state.sensorAnalysis.skyline);

  const { selectedSensor, isVisible } = skylineState;

  const handleClose = () => dispatch(setSkylineVisible(false));

  return (
    <WindowOrSensorSkyline
      type="sensor"
      id={selectedSensor?.id}
      name={selectedSensor?.name}
      isVisible={isVisible}
      handleClose={handleClose}
    />
  );
};

export default SensorSkyline;
